<template>
    <div v-if="mempoolBlocks.length" class="mempool-page">
        <swiper class="swiper blocksCarousel" :options="swiperOption" ref="mySwiper">
          <swiper-slide v-for="(item,index) in allBlocks" :key="index">
            <!-- current blocks -->
            <div v-if="item.type === 'crypto'"
              @click="selectedBlock = item"
              :class="{'selected': item === selectedBlock}"
              class="block">
              <div class="height">#{{item.height}}</div>
              <div class="fees">±  {{item.medianFee ? Math.ceil(item.medianFee) : '???'}} sat/vB</div>
              <div class="fee-span">{{item.feeRange ? `${Math.round(item.feeRange[0])} - ${Math.round(item.feeRange[item.feeRange.length - 1])}` : "???" }} sat/vB</div>
              <div class="block-size">{{bytesToSize(item.size)}}</div>
              <div class="transaction-count">{{addCommas(item.tx_count)}} tx</div>
              <div class="time-difference"> {{moment(item.timestamp * 1000).fromNow()}} </div>
            </div>
            <!-- future blocks -->
            <div v-else 
              @click="selectedFutureBlock = index"
              :class="{'selected': index === selectedFutureBlock, 'mempool': item.type === 'mempool'}"
              class="block">
              <div class="fees">± {{Math.ceil(item.medianFee)}} sat/vB</div>
              <div class="fee-span">{{Math.round(item.feeRange[0])}} - {{Math.round(item.feeRange[item.feeRange.length - 1])}} sat/vB</div>
              <div class="block-size">{{bytesToSize(item.blockSize)}}</div>
              <div class="transaction-count">{{addCommas(item.nTx)}} tx</div>
              <div class="time-difference"> In ~{{(index - blocks.length + 1) * 10}} minutes </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="separator"></div>
        <SelectedBlock
          v-if="selectedBlock"
          :block="selectedBlock"
          @clear-selected-block="selectedBlock = null"
          />
        <SelectedFutureBlock
          v-else-if="selectedFutureBlock"
          :futureBlock="allBlocks[selectedFutureBlock]"
          :index="selectedFutureBlock - blocks.length + 1"
          :BTC_PRICE="BTC_PRICE"
          :darkTheme="darkTheme"
          @clear-selected-future-block="selectedFutureBlock = null"
        />
        <!-- send reversed copy of array blocks -->
        <CommonInfo 
          v-else
          :blocks="blocks.slice().reverse().slice(0,7)"
          :BTC_PRICE="BTC_PRICE"
        />
        <div class="mempool-footer">
          <div v-if="bytesPerSecond">Tx weight per sec: <div class="v-bytes"><span>{{bytesPerSecond}} vBytes/s </span></div></div>
          <div v-if="mempoolInfo.bytes">Mempool size: <span>{{mempoolSize}}</span> </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css';

import SelectedBlock from './selectedBlock'
import SelectedFutureBlock from './selectedFutureBlock'
import CommonInfo from './commonInfo'

const TOKEN =  'pk_7d51a9a624ed43e8adfe4eb3b8d218d0';
const BLOCKS_COUNT = 7;
export default {
  name: 'Mempool',
  props:['darkTheme'],
  components: {
    Swiper,
    SwiperSlide,
    SelectedBlock,
    SelectedFutureBlock,
    CommonInfo,
  },
  data: () => ({
    sliderIsMoving:false,
    selectedBlock:null,
    selectedFutureBlock:null,
    mempoolBlocks:[],
    blocks:[],
    bytesPerSecond: null,
    mempoolInfo: {},
    swiperOption: {
      initialSlide: BLOCKS_COUNT,
      slidesPerView: 11,
      spaceBetween: 0,
      centeredSlides: true,
      allowTouchMove:false
    },
    BTC_PRICE:null
  }),
  computed:{
    mempoolSize(){
      return this.bytesToSize(this.mempoolInfo.bytes)
    },
    swiper(){
      return this.$refs.mySwiper ? this.$refs.mySwiper.$swiper : null
    },
    allBlocks(){
      return [...this.blocks,...this.mempoolBlocks]
    },
  },
  watch:{
    selectedBlock(newValue){
      if (newValue != null){
        this.selectedFutureBlock = null;
      }
    },
    selectedFutureBlock(newValue){
      if (newValue != null){
        this.selectedBlock = null;
      }
    }
  },
  methods:{
    // for the initial page loading
    getMempoolBlocks(){
      axios.get('https://mempool.space/api/v1/fees/mempool-blocks').then(response => {
        if (response.status == 200)
          this.mempoolBlocks = this.addTypeToArr(response.data.slice(0,BLOCKS_COUNT),'mempool');
      });
    },
    connectToMempoolSockets(){
      // connect
      this.$connect('wss://mempool.space/api/v1/ws', { format: 'json' });
      // when socket connected
      this.$socket.onopen = () =>{
        // send initial object
        this.$socket.sendObj({ action: 'want', data: ['mempool-blocks','stats','blocks'] });
        // on socket response
        this.$socket.onmessage = (message) => {
          this.bytesPerSecond = JSON.parse(message.data)['vBytesPerSecond']
          this.mempoolInfo = JSON.parse(message.data)['mempoolInfo']
        
          if (!this.sliderIsMoving){
            this.mempoolBlocks = this.addTypeToArr(JSON.parse(message.data)['mempool-blocks'].slice(0,BLOCKS_COUNT),'mempool');
            // signal to move slider
            if (JSON.parse(message.data)['block']) {
              this.moveSliderBlock(JSON.parse(message.data)['block']);
            }
          }
        }
      }
    },
    getBlocks(){
      axios.get('https://blockstream.info/api/blocks').then(response => {
        if (response.status == 200)
        this.blocks = this.addTypeToArr(response.data.slice(0, BLOCKS_COUNT).reverse(),'crypto')
      });
    },
    addTypeToArr(arr, type){
      arr.forEach(item => {
        item.type = type
      });
      return arr
    },
    moveSliderBlock(block) {
      this.sliderIsMoving = true;
      this.swiper.slideNext(1500);
      this.selectedBlock = null;
      this.selectedFutureBlock = null;
      // clone object 
      this.mempoolBlocks[0] = {...block};
      this.mempoolBlocks[0].type = 'crypto';
      setTimeout(() => {
        let newBlock = this.mempoolBlocks.shift();
        this.blocks.push(newBlock);
        this.getMempoolBlocks();
        this.sliderIsMoving = false;
      }, 2000);
    },
    getBTCPrice(){
      axios.get(`https://cloud.iexapis.com/v1/crypto/BTCUSD/quote?token=${TOKEN}`).then(response => {
          if (response.status == 200)
          this.BTC_PRICE = +response.data.latestPrice
      });
    }
  },
  created(){
    this.getBlocks();
    this.getMempoolBlocks();
    this.connectToMempoolSockets();
    this.getBTCPrice();
  },
};
</script>
<style lang="scss">
.mempool-page{
  min-height: calc(100vh - 103px);
  padding-bottom: 30px;
  .blocksCarousel{
    display: flex;
    justify-content: space-between;
    margin-left: calc((100% - 100vw) / 2);
    margin-right: calc((100% - 100vw) / 2);
    background: var(--block-carousel-bg-color);
    .block{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 125px;
      height: 163px;
      text-align: center;
      background: var(--block-bg-color);
      border: 1px solid var(--block-br-color);
      box-shadow: var(--block-box-shadow);
      border-radius: 16px;
      padding: 18px 10px;
      cursor: pointer;
      position: relative;
      margin: auto;
      margin-top: 30px;
      margin-bottom: 30px;
      transition: .3s ease;
      .height{
        position: absolute;
        top: -23px;
        font-size: 13px;
        left: 25px;
        color: var(--block-height-color);
      }
      .fees, .fee-span{
        font-style: italic;
        font-size: 13px;
      }
      .fees{
        color: var(--block-fees-color);
      }
      .fee-span{
        color: var(--block-fee-span-color);
      }
      .block-size{
        font-size: 18px;
        color: var(--block-size-color);
        font-weight: bold;
      }
      .transaction-count, .time-difference{
        color: var(--block-tx-count-color);
        font-weight: 500;
        font-size: 13px;
      }
      &.mempool{
        background: var(--mempool-bg-color);
        border: 1px solid var(--mempool-br-color);
        &.selected{
          background: var(--mempool-selected-bg-color);
          border: 1px solid var(--mempool-selected-br-color);
        }
      }
      &.selected{
        background: var(--block-selected-bg-color);
        border: 1px solid var(--block-selected-br-color);
      }
    }
  }
  .separator{
    height: 3px;
    background: var(--separator-color);
    margin-left: calc((100% - 100vw) / 2);
    margin-right: calc((100% - 100vw) / 2);
    margin-bottom: 30px;
  }
  .mempool-footer{
    background: var(--mempool-footer-bg-color);
    border: 1px solid var(--mempool-footer-br-color);
    position: fixed;
    left: 0px;
    bottom: 0px;
    width: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;
    font-size: 14px;
    z-index: 5;
    > div{
      display: flex;
      align-items: center;
      margin: 0px 10px;
      color: var(--mempool-footer-font-color);
      .v-bytes{
        background: var(--mempool-footer-vbytes-bg-color);
        border-radius: 6px;
        font-weight: bold;
        font-size: 13px;
        padding: 5px 10px;
        margin-left: 5px;
        position: relative;
        span{
          position: relative;
          color: var(--mempool-footer-vbytes-text-color);
        }
        &:before{
          display: block;
          content: " ";
          background: var(--mempool-footer-vbytes-before-bg-color);
          border-radius: 6px;
          width: 60%;
          height: 30px;
          position: absolute;
          left: 0px;
          top: 0px;
        }
      }
      & > span{
        font-weight: bold;
        font-size: 14px;
        line-height: 21px;
        color: #3868F8;
        margin-left: 5px;
      }
    }
  }
}
</style>
